
/*********************************************************************
 *
 * WARNING: This shader class is automatically generated, any manual
 * edits will be lost.
 *
 ********************************************************************/
import { ShaderBase, ShaderUniformsContainer, ShaderAttributesContainer } from '../shader';
import { Texture, CubeMapTexture } from '../../texture';
import { Context } from '../../context/Context';
import { mat3, mat4, vec2, vec3, vec4 } from "gl-matrix";
import { ShaderSourceParser } from '../shader-source-parser';

export type SkyBoxShaderUniforms = {
	uProjection: WebGLUniformLocation,
	uView: WebGLUniformLocation,
	uSkyboxSampler: WebGLUniformLocation,
	uTintColor: WebGLUniformLocation
};

export type SkyBoxShaderAttributes = {
	aPosition: number,
	vTexCoords: number
};

export type SkyBoxShaderSettings = string[];

export class SkyBoxShader extends ShaderBase<SkyBoxShaderUniforms, SkyBoxShaderAttributes> {

    private static fragmentShaderSource = `
out vec4 fragColor;

uniform samplerCube uSkyboxSampler;
uniform vec3 uTintColor;
in vec3 vTexCoords;
void main(){
	fragColor = vec4(texture(uSkyboxSampler, vTexCoords).rgb * uTintColor, 1.0);
}
`;

    private static vertexShaderSource = `
layout(location = 0) in vec3 aPosition;
uniform mat4 uProjection;
uniform mat4 uView;
out vec3 vTexCoords;
void main(){
	vTexCoords = aPosition;
	gl_Position = uProjection * uView * vec4(aPosition, 1.0);
}
`;

    public override get version(): string {
        return '300 es';
    }

    public override get parser(): any {
        return new ShaderSourceParser();
    }

    protected override get warnAttributeMismatch(): boolean {
        return false;
    }

    public uniformsContainer: SkyBoxShaderUniformsContainer;
    public attributesContainer: SkyBoxShaderShaderAttributesContainer;

    constructor(ctx: Context, settings: SkyBoxShaderSettings) {
        super(ctx, SkyBoxShader.fragmentShaderSource, SkyBoxShader.vertexShaderSource, settings);
        this.uniformsContainer = new SkyBoxShaderUniformsContainer(ctx, this);
        this.attributesContainer = new SkyBoxShaderShaderAttributesContainer(ctx, this);
    }
}

class SkyBoxShaderUniformsContainer extends ShaderUniformsContainer {
    constructor(ctx: Context, private shader: SkyBoxShader) {
        super(ctx);
    }

    public setProjection(value: mat4 | number[]) : SkyBoxShaderUniformsContainer {
        this.setValue('uProjection', this.shader.uniforms.uProjection, value, 'mat4');
        return this;
    }

    public setView(value: mat4 | number[]) : SkyBoxShaderUniformsContainer {
        this.setValue('uView', this.shader.uniforms.uView, value, 'mat4');
        return this;
    }

    public setSkyboxSampler(texture: CubeMapTexture) : SkyBoxShaderUniformsContainer {
        this.setTextureValue('uSkyboxSampler', this.shader.uniforms.uSkyboxSampler, texture, 'samplerCube');
        return this;
    }

    public setTintColor(value: vec3 | number[]) : SkyBoxShaderUniformsContainer {
        this.setValue('uTintColor', this.shader.uniforms.uTintColor, value, 'vec3');
        return this;
    }

    protected getTextureUniforms() {
        return [
			{ name: 'uSkyboxSampler', uniform: this.shader.uniforms.uSkyboxSampler, dataType: 'samplerCube' }
        ];
    }
}

class SkyBoxShaderShaderAttributesContainer extends ShaderAttributesContainer {
    constructor(ctx: Context, private shader: SkyBoxShader) {
        super(ctx);
    }

    public setPosition(settings: { length: number, offset: number, itemSize: number }) : SkyBoxShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aPosition, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setvTexCoords(settings: { length: number, offset: number, itemSize: number }) : SkyBoxShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.vTexCoords, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }
}